import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Flat%20lay%20fashion%20collection%20on%20warm%20beige%20background%2C%20assorted%20sneakers%20bags%20accessories%20caps%20belts%20arranged%20in%20organized%20grid%20pattern%2C%20soft%20natural%20lighting%2C%20editorial%20product%20photography%2C%20clean%20minimalist%20aesthetic%2C%20warm%20neutral%20tones&width=1600&height=800&seq=cta-bg-01&orientation=landscape"
          alt="YOYBUY fashion collection"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-white/85" />
      </div>

      <div className="relative z-10 w-full px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-stone-900 text-white text-xs font-medium rounded-full mb-8">
            <i className="ri-flashlight-line w-4 h-4 flex items-center justify-center" />
            {t('cta.main.title')}
          </div>

          <h2 className="font-heading text-3xl md:text-5xl font-medium text-stone-900 leading-tight">
            {t('cta.main.subtitle')}
          </h2>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 bg-stone-900 text-white text-sm font-semibold rounded-full hover:bg-stone-800 transition-colors whitespace-nowrap shadow-lg shadow-stone-900/10"
            >
              {t('cta.button1')}
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-4 bg-stone-900 text-white text-sm font-semibold rounded-full hover:bg-stone-800 transition-colors whitespace-nowrap shadow-lg shadow-stone-900/10"
            >
              {t('cta.button2')}
              <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center" />
            </a>
          </div>
        </div>

        {/* Larger product showcase strip */}
        <div className="mt-14 flex items-center justify-center flex-wrap gap-3 md:gap-4">
          {[
            'https://readdy.ai/api/search-image?query=White%20sneaker%20product%20shot%20isolated%20on%20white%20background%2C%20clean%20minimalist%20ecommerce%20photography&width=200&height=200&seq=strip-01&orientation=squarish',
            'https://readdy.ai/api/search-image?query=Designer%20handbag%20product%20shot%20isolated%20on%20white%20background%2C%20clean%20minimalist%20ecommerce%20photography&width=200&height=200&seq=strip-02&orientation=squarish',
            'https://readdy.ai/api/search-image?query=Stylish%20watch%20product%20shot%20isolated%20on%20white%20background%2C%20clean%20minimalist%20ecommerce%20photography&width=200&height=200&seq=strip-03&orientation=squarish',
            'https://readdy.ai/api/search-image?query=Fashion%20sunglasses%20product%20shot%20isolated%20on%20white%20background%2C%20clean%20minimalist%20ecommerce%20photography&width=200&height=200&seq=strip-04&orientation=squarish',
            'https://readdy.ai/api/search-image?query=Premium%20cap%20product%20shot%20isolated%20on%20white%20background%2C%20clean%20minimalist%20ecommerce%20photography&width=200&height=200&seq=strip-05&orientation=squarish',
            'https://readdy.ai/api/search-image?query=Fashion%20belt%20product%20shot%20isolated%20on%20white%20background%2C%20clean%20minimalist%20ecommerce%20photography&width=200&height=200&seq=strip-06&orientation=squarish',
            'https://readdy.ai/api/search-image?query=Luxury%20perfume%20bottle%20product%20shot%20isolated%20on%20white%20background%2C%20clean%20minimalist%20beauty%20photography&width=200&height=200&seq=strip-07&orientation=squarish',
            'https://readdy.ai/api/search-image?query=Sporty%20backpack%20product%20shot%20isolated%20on%20white%20background%2C%20clean%20minimalist%20ecommerce%20photography&width=200&height=200&seq=strip-08&orientation=squarish',
          ].map((src, i) => (
            <div
              key={i}
              className="w-20 h-20 md:w-28 md:h-28 rounded-2xl overflow-hidden bg-white shadow-sm hover:shadow-md hover:scale-105 transition-all duration-300"
            >
              <img src={src} alt="product" className="w-full h-full object-cover" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}